export default __webpack_public_path__ + "static/media/guest_02_1_barbara_lima_trampapo.f6dd91a1.png";